<template>
  <template v-if="view==='listar'">
    <HeaderComponent :title="'Permisos de ' + selectedRol.nombre" @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :table-columns="tableColumns" :collection-data="collectionData"
                    :auth-token="authToken" :list-api="listApi"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="{...queries, where: 'rol_id = ' + selectedRol.id + ', table.estado = 1'}"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
</template>
<script>
import {reactive, ref, watch} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import {useLayoutMain} from "@/layouts/main";

/**
 * Un componente para listar los permisos de un rol.
 * @vue-prop {Object} selectedRol - Los datos del rol seleccionado.
 * @vue-data {Array} [collectionData=[]] - Lista los permisos del rol seleccionado.
 */
export default {
  name: 'PermisosRolSubtable',
  props: {
    selectedRol: {
      type: Object,
      required: true,
    },
  },
  emits: ['updateValues'],
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
  },
  data: function () {
    return {
      Object: Object,
      tableColumns: {
        "permiso.nombre": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Nombre",
        },
        "permiso.descripcion": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: "Descripción",
        },
        "estado": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        "created_at": {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: "Fecha de creación",
        },
      }
    }
  },
  async setup(props, {emit}) {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const authToken = ref(authStored.authToken);
    const listApi = reactive({
      list: process.env.VUE_APP_NEST_PERMISOROL_FINDALL,
    });
    watch(view, () => {
      if (view.value === "volver") {
        emit('updateValues', {'view': 'listar'});
      }
    })
    const {
      paginate,
      queries,
      setupUpdateValues
    } = await useLayoutMain(view, collectionData, authToken, undefined, undefined, listApi, {where: 'rol_id = ' + props.selectedRol.id + ', table.estado = 1'});
    return {
      view,
      collectionData,
      authToken,
      listApi,
      paginate,
      queries,
      setupUpdateValues,
      emit
    };
  }
}
</script>